export function validateEmail(email: string) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
}

/**
 * @todo separate length validation from the regex
 * @param name
 * @returns
 */
export function validateName(name: string) {
  const nameRegex = /^[\p{L} .'-]{0,50}$/u;
  return nameRegex.test(name);
}

export function validateBirthyear(year?: number) {
  if (year) {
    const todayYear = new Date().getFullYear();
    return year > 1900 && year < todayYear - 15;
  }
  return true;
}

export function validatePitch(pitch: string) {
  const regex = /^[\p{L}\p{N}\s\n"'(),./+&_?!:-]*$/u;

  if (pitch.indexOf('http://') > -1 || pitch.indexOf('https://') > -1) {
    return false;
  }

  return regex.test(pitch);
}

export function validateEmpty(value: string) {
  return value.trim() !== '';
}

export function validateReview(review: string) {
  const reviewRegex = /^[\p{L}0-9 "'(),\-.+&_?!:\n]*$/u;
  return reviewRegex.test(review);
}

export function validateTag(tag: string) {
  const tagRegex = /^[\p{L}0-9 &-.']*$/u;
  return tagRegex.test(tag);
}

export function validateFileType(file: File, acceptedTypes: ReadonlyArray<string>): boolean {
  return acceptedTypes.includes(file.type as (typeof acceptedTypes)[number]);
}

//@todo: centralize this
export const allowedPitchChars = '"\'(),-./+&_?!:';
export const allowedChars = '"\'(),-./+&_?!:';
export const allowedChars2 = ".-'";
export const allowedChars3 = '"\'(),-./+&_?!:';
export const allowedChars4 = ' &-.';
